
// Aerial - Aerial imagery.
// AerialWithLabels - Aerial imagery with a road overlay.
// AerialWithLabelsOnDemand - Aerial imagery with on-demand road overlay.
// Birdseye - Bird’s eye (oblique-angle) imagery.
// BirdseyeWithLabels - Bird’s eye imagery with a road overlay.
// BirdseyeV2 - The second generation Bird’s eye (oblique-angle) imagery.
// BirdseyeV2WithLabels - The second generation Bird’s eye (oblique-angle) imagerywith a road overlay.
// CanvasDark - A dark version of the road maps.
// CanvasLight - A lighter version of the road maps which also has some of the details such as hill shading disabled.
// CanvasGray - A grayscale version of the road maps.
// Road - Roads without additional imagery. Uses the legacy static tile service.
// RoadOnDemand - Roads without additional imagery. Uses the dynamic tile service.
// OrdnanceSurvey - Ordnance Survey imagery. This imagery is visible only for the London area.


/**
 * @enum {string}
 */
export default {
  ROADMAP: 'RoadOnDemand',
  SATELLITE: 'Aerial',
  HYBRID: 'AerialWithLabels',
};